<template>
  <li>
    <div class="row">
      <div class="col-lg-9">
        <p>{{ decorated.commodity_and_location }}</p>
        <p class="rate"><span>Rate:</span> {{ decorated.rate }}</p>
        <ul class="details">
          <li><span>Loading Date:</span> {{ decorated.loading_date }}</li>
          <li><span>Loading Time:</span> {{ decorated.loading_time }}</li>
        </ul>
      </div>
      <div class="col-lg-3">
        <div class="btn-toolbar">
          <a @click="setLoadRequest" class="btn btn-info" data-toggle="modal" data-target=".modal-load-request"><i class="fa fa-fw fa-map-marker"></i></a>
          <ladda-button type="danger" :disabled="!canEditLoadRequests" :on-click="handleDeclineRequest" ref="decline"><i class="fa fa-fw fa-times"></i></ladda-button>
          <ladda-button type="success" :disabled="!canEditLoadRequests" :on-click="handleAcceptRequest" ref="accept"><i class="fa fa-fw fa-check"></i></ladda-button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { SET_LOAD } from 'vx/mutations'
  import { LaddaButton } from 'components/forms'
  import { loadRequestActionsHelpers, loadHelpers } from 'mixins/loads'
  import $ from 'jquery'

  export default {
    props: ['load'],

    mixins: [loadRequestActionsHelpers, loadHelpers],

    components: {
      LaddaButton
    },

    computed: {
      canEditLoadRequests () {
        return this.$user.isEnabled
      }
    },

    mounted () {
      setTimeout(this.automaticallyAcceptOrDecline, 500)
    },

    methods: {
      ...mapMutations('load', [SET_LOAD]),

      /**
       * Automatically accept or decline a load.
       *
       * @return void
       */
      automaticallyAcceptOrDecline () {
        if (this.$route.name === 'loads.requests.view' && parseInt(this.$route.params.id) === this.load.id && this.$route.params.action) {
          if (this.$refs[this.$route.params.action]) {
            $(this.$refs[this.$route.params.action].$el).trigger('click')
          }
        }
      },

      /**
       * Set the active load request when opening modal.
       *
       * @return void
       */
      setLoadRequest () {
        this[SET_LOAD](this.load)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoadRequestItem.vue?106b1f1e